import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, TextField, Button, Alert } from '@mui/material';
import { resetPassword } from '../api/client';

const ResetPasswordPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [passwords, setPasswords] = useState({ new: '', confirm: '' });
    const [status, setStatus] = useState(null); // success, error
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (passwords.new !== passwords.confirm) {
            alert("Passwords do not match");
            return;
        }

        setLoading(true);
        try {
            await resetPassword(token, passwords.new);
            setStatus('success');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setStatus('error');
        } finally {
            setLoading(false);
        }
    };

    if (!token) return <Typography align="center" sx={{ mt: 4 }}>Invalid Link</Typography>;

    return (
        <Container maxWidth="xs" sx={{ py: 8 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
                <Typography variant="h5" align="center" gutterBottom fontWeight="bold">
                    New Password
                </Typography>

                {status === 'success' && <Alert severity="success" sx={{ mb: 2 }}>Password reset! Redirecting...</Alert>}
                {status === 'error' && <Alert severity="error" sx={{ mb: 2 }}>Failed to reset password.</Alert>}

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth label="New Password" type="password"
                        value={passwords.new} onChange={e => setPasswords({ ...passwords, new: e.target.value })}
                        required margin="normal"
                    />
                    <TextField
                        fullWidth label="Confirm Password" type="password"
                        value={passwords.confirm} onChange={e => setPasswords({ ...passwords, confirm: e.target.value })}
                        required margin="normal"
                    />
                    <Button
                        type="submit" fullWidth variant="contained"
                        size="large" sx={{ mt: 2 }} disabled={loading}
                    >
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </Button>
                </form>
            </Paper>
        </Container>
    );
};

export default ResetPasswordPage;
